import React, { useRef, useState } from "react";
import ReactQuill from "react-quill";
import { Button, Card, CardBody, FormInput, FormTextarea, InputGroup, Modal, ModalBody, ModalHeader } from "shards-react";
import './Editor.css';
import "react-quill/dist/quill.snow.css";
import "../../assets/quill.css";
// import Parchment from 'parchment'
import ImageResize from "quill-image-resize-module"

ReactQuill.Quill.register('modules/ImageResize', ImageResize);
let font = ReactQuill.Quill.import('formats/font')
font.whitelist = [
  'NanumGothic', 'NanumGothicCoding', 'NanumMyeongjo',
'MalgunGothic',
'NotoSans', 'NotoSerif'
]
ReactQuill.Quill.register(font,true)
var FontAttributor = ReactQuill.Quill.import('attributors/class/font');
FontAttributor.whitelist = [
  'NanumGothic', 'NanumGothicCoding', 'NanumMyeongjo',
'MalgunGothic',
'NotoSans', 'NotoSerif','serif'
];
ReactQuill.Quill.register(FontAttributor, true);
// ReactQuill.Quill.register(new Parchment.Attributor.Style('display', 'display', { 
//   whitelist: ['inline']
// }));
// ReactQuill.Quill.register(new Parchment.Attributor.Style('float', 'float', { 
//   whitelist: ['left', 'right', 'center']
// }));
// ReactQuill.Quill.register(new Parchment.Attributor.Style('margin', 'margin', {}));


const CustomToolbar = ({onClickRaw}) => (
  <div id="toolbar">
  <span className='ql-formats'>
    <button className="ql-bold"></button>
    <button className="ql-italic"></button>
    <button className="ql-underline"></button>
    <button className="ql-strike"></button>
  </span>
  <span className='ql-formats'>
    <button className="ql-blockquote"></button>
    <button className="ql-code-block"></button>
  </span>
  <span className='ql-formats'>
    <select className="ql-header">
      <option value="1"></option>
      <option value="2"></option>
      <option value="3"></option>
      <option value="4"></option>
      <option value="5"></option>
      <option value="6"></option>
      <option defaultValue></option>
    </select>
  </span>
  <span className='ql-formats'>
    <button className='ql-list' value='ordered'></button>
    <button className='ql-list' value='bullet'></button>
  </span>
  <span className='ql-formats'>
    <button className="ql-script" value="sub"></button>
    <button className="ql-script" value="super"></button>
  </span>
  <span className='ql-formats'>
    <button className='ql-indent' value='-1'></button>
    <button className='ql-indent' value='+1'></button>
  </span>
  <span className='ql-formats'>
    <select className="ql-font" title="Font">
      <option selected>Normal</option>
      <option class="NanumMyeongjo" value="NanumMyeongjo">나눔명조</option>
      <option class="MalgunGothic" value="MalgunGothic">맑은고딕</option>
      <option class="NotoSans" value="NotoSans">본고딕</option>
      <option class="NotoSerif" value="NotoSerif">본명조</option>
      <option class="serif" value="serif"></option>
      {/* <option defaultValue></option> */}
    </select>
    {/* <select className="ql-size">
      <option value="8px">8px</option>
      <option value="9px">9px</option>
      <option value="10px">10px</option>
      <option value="11px">11px</option>
      <option value="12px">12px</option>
      <option value="13px">13px</option>
      <option value="14px">14px</option>
      <option value="16px">16px</option>
      <option value="18px">18px</option>
      <option value="24px">24px</option>
      <option value="36px">36px</option>
    </select> */}
    <select className="ql-color"></select>
    <select className="ql-background"></select>
  </span>

  <span className='ql-formats'>
    <select className="ql-align"></select>
    {/*<button className="ql-insertStar">
      <CustomButton />
    </button>*/}
  </span>
  <span className='ql-formats'>
    <button className="ql-link"></button>
    <button className="ql-image"></button>
    <button className="ql-video"></button>
  </span>
  <span className='ql-formats'>
    <button className='ql-showhtml' onClick={onClickRaw}>
    <i className="material-icons">code</i>
    {/* Raw */}
    </button>
  </span>
  </div>
)

const Editor = props => {

  const { title, setTitle, content, setContent } = props;
  const [rawHtml, setRawHtml] = useState("");
  const [showRaw, setShowRaw] = useState(false);
  
  const quill = useRef();

  
  const handleChangeRaw= (html)=> {
    setRawHtml(html);
  }
  const handleClickShowRaw = () => {
    if(showRaw === true){
      setContent(rawHtml)
    }
    const isEditingRaw = showRaw;
    
    
    setShowRaw(!isEditingRaw)
    syncViews(isEditingRaw)
  }

  const syncViews= (fromRaw) => {
    if(fromRaw) setContent(rawHtml)
    else setRawHtml(content)
  }

  const modules = {
    // font,
    ImageResize:{
      displayStyles:{
        backgroundColor:'black',
        border:'none',
        color:'white'
      },
      modules:['Resize','DisplaySize','Toolbar'],
    },
  toolbar: {container: '#toolbar',
  handlers:{
  }
  }
};

  const formats = [
    'header',
		'bold', 'italic', 'underline', 'strike',
		'blockquote', 'code-block',
		'list', 'bullet',
		'script',
		'indent',
		'link', 'image',
		'size',
    'font',
		'color', 'background',
    'code',
    'display',
    'width',
    'height',
    'float',
    'align',
    'family'
  ]
  
  const onChange = e => {
    const {
      target: { value }
    } = e;
    setTitle(value);
  };
  
  return (
    <Card small className="mb-3">
      <CardBody>
        {/* <Form className="add-new-post"> */}
        
          <FormInput
            size="lg"
            className="mb-3"
            placeholder="Your Post Title"
            value={title}
            onChange={onChange}
            name="title"
          />
          
          <CustomToolbar onClickRaw={handleClickShowRaw}/>
          <ReactQuill
            id='editor'
            theme="snow"
            ref={quill}
            modules={modules}
            className="add-new-post__editor mb-1"
            placeholder="기사를 입력해주세요."
            onChange={setContent}
            value={content || ""}
            name="content"
            formats={formats}
            
          >

          </ReactQuill>
          
          <Modal size="lg" open={showRaw} centered={true}>
                  <ModalHeader className="d-block">
                    {title.slice(0,40) + (title.length > 40 ? "..." : "")}
                    <div
                      onClick={()=>{
                        handleClickShowRaw()
                      }}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "1rem",
                        top: "1rem"
                      }}
                    >
                      <i className="material-icons">close</i>
                    </div>
                  </ModalHeader>
                  <ModalBody>
                      <InputGroup className="mb-3">
                        <FormTextarea style={{height:"70vh"}} size="lg" onChange={(e)=> (handleChangeRaw(e.target.value))} value={rawHtml} />
                      </InputGroup>
                      <Button style={{marginLeft:"calc(100% - 1.875rem - 28px)"}} onClick={handleClickShowRaw}>완료</Button>
                  </ModalBody>
                </Modal>
        {/* </Form> */}
      </CardBody>
    </Card>
  );
};

export default Editor;
